// extracted by mini-css-extract-plugin
export default {"tagContainer":"tagContainer__ZGM3M","tagText":"tagText__NDQwM","icon":"icon__MTgwO"};